import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import classNames from 'classnames/bind';
import ScriptLoader from 'yoda-core-components/lib/helpers/ScriptLoader/ScriptLoader';
import Button from 'yoda-core-components/lib/components/Button/Button';
import Rating from 'yoda-core-components/lib/components/Rating/rating';
import { detectisEdge, detectisIE } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './BVSummary.css';
import AnalyticsAction from '../../actions/AnalyticsAction';
import ProductImageActions from '../../actions/ProductImageActions';
import { BVReviewsLoading, BVReviewsLoaded } from '../../actions/BVReviewsAction';
import { selectFeatureFlags, selectPreferences } from '../../selectors/ContextSelector';
import { BUNDLE } from '../../common/Constants';

const cx = classNames.bind(styles);
let shouldSmoothScroll = true;

const MAX_SHOWINFO_RETRY_COUNT = 4;
let retryShowInfoCount = 0;
let showInfoTimeoutId;

export function getTop(elem, deviceType = {}) {
    const stickyHeaderHeight = 90;

    let result =
        deviceType.isMobile || deviceType.isTablet
            ? elem.getBoundingClientRect().top
            : elem.offsetTop;

    result = elem.offsetHeight !== 0 ? result - stickyHeaderHeight : result;

    return result;
}

export class BVSummary extends Component {
    static defaultProps = {
        actions: {},
        deviceType: {},
        isAccordion: false,
        productDetails: {},
        fromMiniPDP: false,
        primaryProductDisplay: false,
        featureFlags: {},
        BVReviews: { isLoaded: undefined },
        preferences: {},
        isBundle: false,
    };

    static propTypes = {
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        isAccordion: PropTypes.bool,
        productDetails: PropTypes.object,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        fromMiniPDP: PropTypes.bool,
        primaryProductDisplay: PropTypes.bool,
        featureFlags: PropTypes.object,
        BVReviews: PropTypes.object,
        preferences: PropTypes.oneOfType([PropTypes.object]),
        isBundle: PropTypes.bool,
    };

    getBVUrl = () => {
        const { preferences } = this.props;
        let productType = '';
        productType = 'allProducts';
        const bvURL = get(preferences, `bazaarVoice.${productType}`);
        if (!bvURL) {
            console.error('Please add bazaar voice urls to the configuration');
        }

        return bvURL;
    };

    loadScript = () => {
        const { actions } = this.props;
        const bvURL = this.getBVUrl();

        if (this.getBVUrl) {
            const bazzarVoiceLibProps = {
                src: bvURL,
                async: true,
                defer: false,
                onSuccess: actions.BVReviewsLoaded,
            };
            ScriptLoader.load(bazzarVoiceLibProps);
            actions.BVReviewsLoading();
        }
    };

    isBVLoaded = () => {
        const container =
            document.getElementById('BVReviewsContainer') ||
            document.getElementById('BVQuestionsContainer');
        const hasChildNodes = (container && container.hasChildNodes()) || false;
        return hasChildNodes;
    };

    showInfoViewSection = (value = '') => (event) => {
        retryShowInfoCount += 1;
        const { deviceType, actions, BVReviews, featureFlags, productDetails } = this.props;
        let element = null;
        const isBVLoaded = this.isBVLoaded();
        const isReviewAvailable =
            productDetails &&
            productDetails.valuation &&
            productDetails.valuation.reviews &&
            productDetails.valuation.reviews.count > 0;

        const isQuestionAvailable =
            productDetails &&
            productDetails.valuation &&
            productDetails.valuation.questionCount &&
            productDetails.valuation.questionCount > 0;

        /* istanbul ignore next */
        if (value === 'PR' && deviceType.isDesktop) {
            !isBVLoaded ? actions.BVReviewsLoading() : actions.BVReviewsLoaded();
            event && actions.pdpToolClickAnalytics('ratings and reviews');
        }
        /* istanbul ignore next */
        if (value === 'QA') {
            if (!isQuestionAvailable && featureFlags.enableWriteReviewFromTeaser) {
                if (BVReviews.isLoaded) {
                    window.$BV.ui('qa', 'submit_question', { productId: productDetails.id });
                } else {
                    !BVReviews.isLoaded && this.loadScript();
                    showInfoTimeoutId = setTimeout(this.showInfoViewSection(value), 450);
                }
            } else {
                element = document.getElementById('QASectionId');
            }
        } else if (!isReviewAvailable && featureFlags.enableWriteReviewFromTeaser) {
            if (BVReviews.isLoaded) {
                window.BV.ui('rr', 'submit_review', { productId: productDetails.id });
            } else {
                !BVReviews.isLoaded && this.loadScript();
                showInfoTimeoutId = setTimeout(this.showInfoViewSection(value), 450);
            }
        } else {
            element = document.getElementById('reviewSectionId');
        }

        const resultElement = element;

        if (resultElement) {
            const top = getTop(resultElement, deviceType) - 25;
            const isExpanded = get(featureFlags, 'bazaarVoice', true)
                ? resultElement?.parentElement?.parentElement?.getAttribute('aria-expanded')
                : get(resultElement, 'parentNode.dataset.isExpanded', '');
            if ((deviceType.isMobile || deviceType.isTablet) && isExpanded !== 'true') {
                resultElement.click();
            }
            if (
                get(featureFlags, 'enableDesktopAccordionBV', true) &&
                deviceType.isDesktop &&
                isExpanded !== 'true'
            ) {
                resultElement.click();
            }
            /* istanbul ignore else */
            if (!detectisIE() && !detectisEdge()) {
                setTimeout(() => {
                    window.scrollTo({
                        top,
                        behavior: shouldSmoothScroll ? 'smooth' : 'auto',
                        block: 'start',
                    });
                }, 100);
            } else {
                element.scrollIntoView({
                    behavior: shouldSmoothScroll ? 'smooth' : 'auto',
                    block: 'start',
                });
            }

            /* istanbul ignore next */
            if (isBVLoaded === false && !deviceType.isMobile && !deviceType.isTablet) {
                shouldSmoothScroll = false;
                showInfoTimeoutId = setTimeout(this.showInfoViewSection(value), 450);
            } else if (isBVLoaded) {
                shouldSmoothScroll = true;
            }
            if (retryShowInfoCount === MAX_SHOWINFO_RETRY_COUNT && showInfoTimeoutId) {
                retryShowInfoCount = 0;
                clearTimeout(showInfoTimeoutId);
                showInfoTimeoutId = 0;
            }
            return event && setTimeout(actions.removeImageSticky, 0);
        }

        return null;
    };

    ratingsSummary(fromMiniPDP) {
        if (fromMiniPDP) return this.miniPdpReviewCount();
        return this.props.deviceType.isMobile
            ? this.mobileReviewsCount()
            : this.nonMobileReviewCount();
    }

    miniPdpReviewCount() {
        const { productDetails } = this.props;
        if (
            productDetails &&
            productDetails.valuation.reviews &&
            productDetails.valuation.reviews.count > 0
        ) {
            const reviewCountArr = productDetails.valuation.reviews.count.toString().split('');
            const reviewCount = reviewCountArr
                .map((digit, index) => {
                    /* istanbul ignore next */
                    if (index && (reviewCountArr.length - index) % 3 === 0) {
                        return `,${digit}`;
                    }
                    return digit;
                })
                .join('');

            return <div className={cx('miniPdpReviewBtn')}>{reviewCount}</div>;
        }
        return null;
    }

    nonMobileReviewCount() {
        return (
            <div className={`${cx('ratingSummary')} ${dt(['mdOnly:mt-0'])}`}>
                {this.renderRRSection()}
                {this.renderQASection()}
            </div>
        );
    }

    mobileReviewsCount() {
        const {
            productDetails: { valuation },
            isAccordion,
        } = this.props;
        return (
            <div className={cx('ratingSummary')}>
                {isAccordion ? (
                    <span
                        className={dt([
                            valuation.reviews && typeof valuation.reviews.count !== 'undefined'
                                ? 'ml-2'
                                : '',
                        ])}
                    >
                        {valuation.reviews && typeof valuation.reviews.count !== 'undefined'
                            ? `(${valuation.reviews.count})`
                            : null}
                    </span>
                ) : (
                    this.renderRRSection()
                )}
            </div>
        );
    }

    renderRRSection() {
        const { productDetails, isBundle } = this.props;
        const bundleRatingBtnStyle = isBundle ? [dt(['m-0.5'])] : [''];
        if (
            productDetails &&
            productDetails.valuation.reviews &&
            productDetails.valuation.reviews.count > 0
        ) {
            const showInfoView = this.showInfoViewSection('PR');
            const buttonType = 'Link';
            return (
                <Button
                    buttonType={buttonType}
                    buttonId="BVSummaryReviewBtn"
                    className={cx('reviewBtn', bundleRatingBtnStyle)}
                    onClick={showInfoView}
                >
                    {productDetails.valuation.reviews.count} Reviews
                </Button>
            );
        }
        const writeReviewSection = (
            <Button
                buttonType="Link"
                className={cx('reviewBtn', bundleRatingBtnStyle)}
                onClick={this.showInfoViewSection('PR')}
            >
                Write a Review
            </Button>
        );
        return writeReviewSection;
    }

    renderQASection() {
        const { productDetails, primaryProductDisplay } = this.props;
        const displayPipe = !primaryProductDisplay ? (
            <span className={cx('divider')}> &nbsp; | &nbsp; </span>
        ) : null;
        /* istanbul ignore next */
        if (
            productDetails &&
            productDetails.valuation &&
            productDetails.valuation.questionCount &&
            productDetails.valuation.questionCount > 0
        ) {
            const showInfoView = this.showInfoViewSection('QA');
            return (
                <span className={dt(['smMd:hidden'])}>
                    {displayPipe}
                    <Button buttonType="Link" className={cx('QABtn')} onClick={showInfoView}>
                        {productDetails.valuation.questionCount} Questions &{' '}
                        {productDetails.valuation.answerCount} Answers
                    </Button>
                </span>
            );
        }
        /* istanbul ignore next */
        return (
            <span className={dt(['smMd:hidden'])}>
                {displayPipe}
                <Button
                    buttonType="Link"
                    className={cx('QABtn')}
                    onClick={this.showInfoViewSection('QA')}
                >
                    Ask a Question
                </Button>
            </span>
        );
    }

    renderRRQASection() {
        const {
            productDetails: { valuation, type },
            isAccordion,
            fromMiniPDP,
            primaryProductDisplay,
            isBundle,
            featureFlags,
        } = this.props;
        const valuationRating = valuation && valuation.rating ? valuation.rating : 0;
        let ratingStyle = '';
        if (isAccordion) {
            if (get(featureFlags, 'enableDesktopAccordionBV', true)) {
                ratingStyle = 'ml-3';
            } else {
                ratingStyle = 'smMd:ml-3';
            }
        }

        const reviewCount = (
            <div
                className={`${dt(['float-left', 'inline-block', fromMiniPDP && 'py-1'])} ${cx(
                    fromMiniPDP ? 'fromMiniPDP' : ''
                )}`}
            >
                <Rating
                    averageRating={valuationRating}
                    totalRatings={5}
                    ratingIconSize="small"
                    wrapperClassName={`${cx('rating')} ${dt([ratingStyle])}`}
                    showZeroRatings
                    iconWrapperStyle={dt(['sm:!mr-2'])}
                />
            </div>
        );

        const accordionRatingContainer = (
            <span className={`${cx('accordionRatingContainer')} ${dt(['flex', 'items-center'])}`}>
                {this.mobileReviewsCount()}
                {reviewCount}
            </span>
        );
        const bundleStyles = type === BUNDLE ? dt(['mb-4']) : dt(['md:mb-3']);
        const summaryRatingContainer = (
            <div
                className={`${cx('summaryRatingContainer', { miniPDPRating: fromMiniPDP })} ${dt([
                    'flex',
                    'items-center',
                ])} ${bundleStyles}`}
            >
                {reviewCount}
                {this.ratingsSummary(fromMiniPDP)}
            </div>
        );

        return (
            <div
                className={cx('ratingContainer', {
                    primaryProductTitle: primaryProductDisplay,
                })}
            >
                {/* eslint-disable no-nested-ternary */}
                {valuation ? (isAccordion ? accordionRatingContainer : summaryRatingContainer) : ''}
            </div>
        );
    }

    render() {
        const { productDetails } = this.props;
        const rrqaContent =
            Object.keys(productDetails).length > 0 && productDetails.valuation
                ? this.renderRRQASection()
                : null;
        return rrqaContent;
    }
}

const mapStateToProps = (state) => ({
    deviceType: state.context ? state.context.deviceType : {},
    featureFlags: selectFeatureFlags(state),
    BVReviews: state.BVReviews,
    preferences: selectPreferences(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...AnalyticsAction,
            ...ProductImageActions,
            BVReviewsLoading,
            BVReviewsLoaded,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(BVSummary);
